import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, functions } from '../../firebase'; // Si usas Firebase para la autenticación
import { httpsCallable } from 'firebase/functions';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './Payment.css'; // Asegúrate de tener el archivo de estilos

const SuccessPayment = () => {
  const { t } = useTranslation(); // Hook para traducciones
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL; // URL de tu API

  useEffect(() => {
    const updateUserPlan = async () => {
      try {
        auth.onAuthStateChanged(async (user) => {
          if (user) {
            // El usuario está autenticado
            console.log('Usuario autenticado:', user);
            await sendPaymentSuccessfulEmail(user.email, user.displayName);
            console.log('Usuario actualizado a premium');
          } else {
            console.error('No se encontró un usuario autenticado');
            // Aquí podrías redirigir al usuario para que se autentique si es necesario
          }
        });
      } catch (error) {
        console.error('Error al actualizar el plan del usuario:', error);
      }
    };

    updateUserPlan();
  }, []);

  const sendPaymentSuccessfulEmail = async (email, displayName) => {
    try {
      console.log("MANDANDO MAIL DE CONFIRMACIÓN DE PAGO PREMIUM");
      const sendWelcomeEmail = httpsCallable(functions, 'sendWelcomeEmail');

      const logoUrl = 'https://reveat.pro/assets/images/RevEat_Logo_PNG.png';
      const reveatYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim();

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Confirmación de Pago</title>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
           <style type="text/css">
                  @media screen {
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 400;
                          src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v11/qIIYRU-oROkIk8vfvxw6QvesZW2xOQ-xsNqO47m55DA.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 700;
                          src: local('Lato Bold'), local('Lato-Bold'), url(https://fonts.gstatic.com/s/lato/v11/qdgUG4U09HnJwhYI-uK18wLUuEpTyoUstqEm5AMlJo4.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 400;
                          src: local('Lato Italic'), local('Lato-Italic'), url(https://fonts.gstatic.com/s/lato/v11/RYyZNoeFgb0l7W3Vu1aSWOvvDin1pK8aKteLpeZ5c0A.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 700;
                          src: local('Lato Bold Italic'), local('Lato-BoldItalic'), url(https://fonts.gstatic.com/s/lato/v11/HkF_qI1x_noxlxhrhMQYELO3LdcAZYWl9Si6vvxL-qU.woff) format('woff');
                      }
                  }
                  body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
                  table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
                  img { -ms-interpolation-mode: bicubic; }
                  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
                  table { border-collapse: collapse !important; }
                  body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
                  a[x-apple-data-detectors] { color: inherit !important; text-decoration: none !important; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit !important; }
                  @media screen and (max-width:600px) { h1 { font-size: 32px !important; line-height: 32px !important; } }
                  div[style*="margin: 16px 0;"] { margin: 0 !important; }
              </style>
        </head>
        <body style="background-color: #f4f4f4; margin: 0 !important; padding: 0 !important;">
          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
              <td bgcolor="${reveatYellow}" align="center">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td align="center" valign="top" style="padding: 40px 10px 40px 10px;">
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="${reveatYellow}" align="center" style="padding: 0px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#ffffff" align="center" valign="top" style="padding: 40px 20px 20px 20px; border-radius: 4px 4px 0px 0px; color: #111111; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 48px; font-weight: 400; line-height: 48px;">
                      <h1 style="font-size: 48px; font-weight: 400; margin: 2;">¡Felicidades ${displayName}!</h1>
                       <img src="${logoUrl}" width="160" height="120" style="display: block; border: 0px; margin : 30px 20px 20px 20px" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f4f4f4" align="center" style="padding: 0px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#ffffff" align="left" style="padding: 20px 30px 40px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;text-align:center">
                      <p style="margin: 0;">Gracias por actualizar a la cuenta <b>Premium</b> en Reveat. Ahora tendrás acceso a todas nuestras funcionalidades exclusivas. <br> <br> ¡Es hora de empezar a aprovechar al máximo nuestras herramientas para llevar tu restaurante al siguiente nivel!</p>
                      <br><p style="margin: 0;"><b>Ventajas de ser Premium:</b><br>
                        - Acceso ilimitado a informes de todo tipo.<br>
                        - Visualiza todas las gráficas comparativas con otros negocios.<br>
                        - Obtén insights más detallados para mejorar tu rendimiento.<br><br>
                        Empieza a explorar tu nueva cuenta Premium y descubre todas las oportunidades que te esperan.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td bgcolor="#ffffff" align="center" style="padding: 20px 30px 60px 30px;">
                      <a href="${window.location.origin}/dashboard" target="_blank" style="font-size: 20px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; padding: 15px 25px; border-radius: 20px; background-color: ${reveatYellow}; border: 1px solid ${reveatYellow};">Accede a tu Dashboard Premium</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f4f4f4" align="center" style="padding: 30px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#FFFFFF" align="center" style="padding: 30px 30px 30px 30px; border-radius: 4px 4px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                      <h2 style="font-size: 20px; font-weight: 400; color: #111111; margin: 0;">¿Tienes alguna duda?</h2>
                      <p style="margin: 0;"><a href="${window.location.origin}/faq" target="_blank" style="color: ${reveatYellow};">Estamos aquí para ayudarte</a></p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
        </html>
      `;

      const result = await sendWelcomeEmail({
        to: email,
        subject: `¡Bienvenido a Premium, ${displayName}!`,
        text: `Hola ${displayName}, gracias por unirte a Reveat Premium. Ahora tienes acceso ilimitado a todas nuestras funcionalidades.`,
        html: htmlContent
      });

      console.log('Email de confirmación de pago enviado:', result.data);
    } catch (error) {
      console.error('Error al enviar el email de confirmación de pago:', error);
    }
  };

  return (
    <div className="success-container">
      <div className="payment-card">
        <div className="payment-card-body">
          <h1 className="payment-card-title">{t('successfullPaymentTitle')}</h1>
          <p className="payment-card-text">
            {t('successfullPaymentBody')}
          </p>
          <p>{t('successfullPaymentFooter')}</p>
          {/* Botón para volver a la página de inicio o dashboard */}
          <a href="/dashboard" className="btn btn-basic mt-4">
            {t('successfullPaymentHome')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessPayment;
